import { useEffect, useRef, useState } from 'react';

export const useTimer = () => {
  const [timeInMs, setTimeInMs] = useState(0);
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const start = () => {
    if (timerRef.current !== null) return; // Prevent multiple intervals
    // interval every xx ms
    const startTime = Date.now();
    timerRef.current = setInterval(() => {
      setTimeInMs(Date.now() - startTime);
    }, 1000);
  };

  const stop = () => {
    if (timerRef.current !== null) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  };

  const reset = () => {
    stop();
    setTimeInMs(0);
  };

  useEffect(() => {
    return () => {
      stop(); // Cleanup on unmount
    };
  }, []);

  return {
    start,
    stop,
    reset,
    timeInMs,
    timeInSec: Math.floor(timeInMs / 1000),
  };
};
